<template>
  <div class="navbar-option" @click="onClick">
    <div
      :class="[
        'navbar-option__text',
        { ['text-accent-700 font-bold']: selectedLink },
      ]"
    >
      {{ $t(displayText) }}
    </div>
    <div
      :class="[{ ['hidden']: !selectedLink }, 'navbar-option__highlight']"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { navigateTo } from "nuxt/app";

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  displayText: {
    type: String,
    required: true,
  },
  path: {
    type: String,
    required: true,
  },
  selectedLink: {
    type: Boolean,
    default: false,
  },
  activeGroup: {
    type: String,
    default: "Monitor",
  },
});

async function onClick() {
  const isExternal =
    (props.path?.includes("pro/#") ||
      props.path?.includes("reports#/") ||
      props.path?.includes("/manage/articles")) ??
    false;

  await navigateTo(props.path, {
    external: isExternal,
  });
}
</script>

<style lang="scss" scoped>
.navbar-option {
  @apply h-18 flex items-center cursor-pointer text-accent-500 hover:text-accent-900 relative;
}

.navbar-option__text {
  @apply font-body-2-strong;
}

.navbar-option__highlight {
  @apply w-full h-1 rounded-t bg-secondary-600 absolute bottom-0 left-0;
}
</style>
